<div cslPerfectScrollbar class="content-wrapper flex flex-row items-stretch">
  <div class="cutout-list-wrapper mr-4 flex flex-col space-y-2 items-stretch basis-200" cslPerfectScrollbar>
    <csl-cutouts-creator
      [panelHeight]="tempPanel.height"
      [panelWidth]="tempPanel.width"
      [schema]="schema"
      (cutoutChanged)="formChangeHandler($event)"
      (statusChange)="stateChanged$.next($event === 'VALID')"></csl-cutouts-creator>
  </div>

  <div cslPerfectScrollbar class="flex flex-col items-start flex-1">
    <csl-svg-workspace class="panel-schema" #svgWorkspace [p]="tempPanel"> </csl-svg-workspace>
  </div>
</div>
